export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/feature-manage.fb6f6836-d56957.png";